import {call, put, takeLatest, select} from "redux-saga/effects";
import {orderActions, orderFilterSelector, orderPaginationSelector} from "./orderSlice";
import {orderApi} from "~/api";

function* fetchData() {
	try {
		const filter = yield select(orderFilterSelector);
		const pagination = yield select(orderPaginationSelector);

		const params = {
			...filter,
			page: pagination.page,
			limit: pagination.limit,
		};

		const response = yield call(orderApi.gets, params);

		if (response.status === 'success') {
			yield put(orderActions.fetchDataSuccess({
				data: response.data || [],
				pagination: response.pagination || pagination,
			}));
		} else {
			yield put(orderActions.fetchDataFailed(response.message || 'Lỗi khi tải dữ liệu'));
		}
	} catch (error) {
		yield put(orderActions.fetchDataFailed(error.message || 'Lỗi khi tải dữ liệu'));
	}
}

export default function* orderSaga() {
	yield takeLatest(orderActions.fetchData.type, fetchData);
}
